export const customerKeys = {
  customer_overlay_status: (customerId: string) =>
    ['CUSTOMER_OVERLAY_STATUS', customerId] as const,
};
